(() => {
  const root = document.documentElement;

  // Dimension lines draw once after first paint; CSS holds them collapsed while .js-dim-pending is set.
  const releaseDimensions = () => {
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('js-dim-pending')));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', releaseDimensions, { once: true });
  } else {
    releaseDimensions();
  }

  const setupScroller = (scroller) => {
    if (scroller.dataset.ready) return;
    scroller.dataset.ready = 'true';
    const track = scroller.querySelector('.ceme-scroller__track');
    const prev = scroller.querySelector('[data-scroll="prev"]');
    const next = scroller.querySelector('[data-scroll="next"]');
    if (!track) return;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      scroller.classList.toggle('is-static', max <= 0);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };

    const step = (direction) => {
      const item = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.9;
      track.scrollBy({ left: direction * distance });
    };

    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const initScrollers = (root = document) => root.querySelectorAll('[data-ceme-scroller]').forEach(setupScroller);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initScrollers(), { once: true });
  } else {
    initScrollers();
  }
  document.addEventListener('shopify:section:load', (event) => initScrollers(event.target));

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-ceme-variant]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    const scope = select.closest('.product-details');
    if (!scope || !option) return;
    const button = scope.querySelector('[data-ceme-add]');
    const price = scope.querySelector('[data-ceme-price]');
    if (price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.availableLabel;
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', select.value);
    history.replaceState({}, '', url);
  });
})();
